<template>
    <div class="p-menu">
        <h5 class="text-center">Company Blocks</h5>
        <div class="flex align-items-center">
            <Checkbox v-model="onlyDefault" inputId="default" :binary="true" />
            <label for="default" class="ml-2">Only Default</label>
        </div>
        <Divider />
        <div class="blocklist-container">
            <ScaleLoader v-if="filteredBlocks.length <=0" />
            <Accordion v-else :activeIndex="0">
                <AccordionTab header="All Blocks">
                    <div class="flex flex-column blocklist">
                        <div v-for="block in filteredBlocks" :key="block" class="draggable-block">
                            <div
                                class="flex justify-content-between p-2 mt-2"
                                :draggable="true"
                                @dragstart="emit('dragged-block', block)"
                                @click="emit('dragged-block', block)"
                            >
                                <Badge
                                    class="mr-2"
                                    v-if="blockVersionExists(block.code)"
                                    v-tooltip="'Block version ' + blockVersionExists(block.code) + ' already exists in this assessment'"
                                >
                                    <i class="pi pi-check"></i>
                                </Badge>
                                {{block.name}}
                                <Badge :value="'v'+block.version" severity="warning" />
                            </div>
                        </div>
                    </div>
                </AccordionTab>
            </Accordion>
        </div>
    </div>
</template>

<script setup>
import { ref, watch, onMounted, defineEmits, computed, inject } from 'vue';
import { useBlockStore } from '@/products/pha/modules/block/store';
import { SharedTypes } from '@/enums';

const emit = defineEmits(['dragged-block']);
const blockStore = useBlockStore();
const builderStore = inject('builderStore');
const onlyDefault = ref(true);

onMounted(async () => {
	await fetchBlocks();
});

watch(onlyDefault, async () => {
	await fetchBlocks();
});

const fetchBlocks = async () => {
	await blockStore.fetchAllBlocks(SharedTypes.COMPANY, { default: onlyDefault.value ? true : null });
};

const filteredBlocks = computed(() => {
	return blockStore.blocks?.filter((block) => {
		return block.attributes && block.attributes.length > 0;
	});
});

// to check if the block version from block list is already dragged or already exists in the droppedBlock list
const blockVersionExists = (blockCode) => {
    const blockExists = builderStore.droppedBlocks?.filter((block) => block !== null)?.find((block) => block.code === blockCode);
    return blockExists ? blockExists?.version : false;
};
</script>

<style lang="scss">
.blocklist-container {
	height: 70vh;
	overflow: auto;
    padding-bottom: 50px;
	.blocklist {
		overflow-y: auto;
		.draggable-block {
			border: 1px solid #e4e5e5;
			// background: #f6f9fe;
		}
	}
	.p-accordion-content {
		padding: 0rem !important;
	}
}
</style>
